import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import globalContext from "../contexts/global";
import { removeUser, updateAccessToken } from "../contexts/UserContext/actions";

export const apiClient = (): AxiosInstance => {
  const { userContext } = globalContext.call
  const { user, dispatch } = userContext
  const { access_token, language } = user

  const headers: Record<string, string | boolean> = {
    Authorization: access_token ? `Bearer ${access_token}` : 'no',
    'Accept-Language': language
  }

  if (access_token) headers['Access-Control-Allow-Credentials'] = true

  const params: AxiosRequestConfig = {
    baseURL: `${import.meta.env.VITE_API_URL}/api`,
    headers,
    withCredentials: false,
  }

  const ac = axios.create(params)
  ac.interceptors.response.use((response) => response, async (error) => {
    const originalRequest = error.config
    if (error?.response?.status === 401 && !originalRequest._retry) {
      const refreshTokenString = '/token/refresh/'
      originalRequest._retry = true
      const { refresh_token } = user
      // Do not allow retry if refresh returns 401
      if (refresh_token && originalRequest.url !== refreshTokenString) {
        try {
          const resp = await ac.post(refreshTokenString, {
            refresh: refresh_token
          })
          dispatch(updateAccessToken(resp.data.access))
          originalRequest.headers.Authorization = `Bearer ${resp}`
          return axios(originalRequest)
        } catch (error) {
          dispatch(removeUser())
        }
      } else if (originalRequest.url === refreshTokenString) {
        dispatch(removeUser())
      }
    }
    return Promise.reject(error)
  })

  return ac
}
